import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useFetch } from '../../hooks/useFetch';
import { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
  Card,
  Paper,
  CardActions,
  CardContent,
} from '@mui/material/';
import format from 'date-fns/format';
import EditIcon from '@mui/icons-material/Edit';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DataGridView from '../../components/DataGridView';
import PageviewIcon from '@mui/icons-material/Pageview';
import PreviewIcon from '@mui/icons-material/Preview';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DescriptionIcon from '@mui/icons-material/Description';
import ExaminationAuthList from './ExaminationAuthList';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import RemoveExamAuth from './RemoveExamAuth';
function ViewAuthList({
  sessionId,
  academicYear,
  studentId,
  campusId,
  setViewExams,
  setViewTerms,
  venueId,
}) {
  const { user, accessLevel, parentID, token } = useAuthContext();

  const [addExam, setAddExam] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [removeExam, setRemoveExam] = useState(0);
  const [removeId, setRemoveId] = useState('');

  const [examCount, setExamCount] = useState(0);
  const {
    postData,
    error,
    isPending,
    data: authList,
  } = useFetch('https://pcapi.bi-oss.co.za/studcambridge/authorisationlist');

  useEffect(() => {
    if (studentId && campusId && academicYear && sessionId) {
      postData({
        studentId,
        campusId,
        sessionId,
        academicYear,
      });
    }
  }, [studentId, campusId, academicYear, sessionId]);

  useEffect(
    (tableData) => {
      if (authList) {
        setExamCount(0);
        setTableData(authList);
        authList.map((data) => {
          if (data.studentConf === 1) {
            setExamCount(1);
          }
        });
      }
    },
    [authList],
  );

  const columns = [
    { field: 'academicYear', headerName: 'Year:', width: 120, editable: true },
    { field: 'session', headerName: 'Session:', width: 120, editable: true },
    {
      field: 'qualification',
      headerName: 'Qualification:',
      width: 130,
      editable: true,
    },
    { field: 'camCode', headerName: 'Course:', width: 120, editable: true },
    {
      field: 'paperCode',
      headerName: 'Combination:',
      width: 120,
      editable: true,
    },
    {
      field: 'description',
      headerName: 'Paper Description:',
      width: 300,
      editable: true,
    },

    {
      field: 'action1',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => {
        const onClick2 = (e) => {
          e.stopPropagation(); // don't select this row after clicking

          setRemoveId(params.row.id);
          setRemoveExam(1);
        };

        if (params.row.studentConf === 1) {
          return (
            <Button
              color="primary"
              onClick={onClick2}
              fullWidth
              variant="contained"
            >
              Remove <RemoveCircleIcon />
            </Button>
          );
        }
      },
    },
  ];

  const handleComplete = (e) => {
    setRemoveId('');
    setAddExam(0);
    setRemoveExam(0);
    postData({
      studentId,
      campusId,
      sessionId,
      academicYear,
    });
  };

  const handleOnCellClick = (e) => {
    // window.open(e.row.fileURL, '_blank')
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setViewExams(0);
    setViewTerms(1);
  };
  return (
    <>
      {isPending && (
        <Container maxWidth="lg">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="h6" component="h3" color="primary.main">
                  Fetching examination cart details ...
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}

      {!isPending && !addExam && !removeExam && (
        <Container maxWidth="lg">
          <Box mb={5} />
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    variant="h3"
                    component="h3"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Examination Cart
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    <b>Entry Process:</b> Add your required examination paper
                    combinations to your cart.
                  </Typography>
                </Box>
              </Grid>

              {!isPending && !error && tableData && tableData.length === 0 && (
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2" component="p" color="error">
                      <b>
                        There are currently no examinations in the candidate’s
                        cart.
                      </b>
                    </Typography>
                  </Box>
                </Grid>
              )}
              {!isPending && !error && tableData && (
                <Grid item xs={12} minWidth={0}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <DataGridView
                      tableData={tableData}
                      error={error}
                      isPending={isPending}
                      getFormattedDate={null}
                      columns={columns}
                      pageSize={15}
                      handleOnCellClick={handleOnCellClick}
                      getRowId={(row) => row.id}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Button
                        fullWidth
                        color={'primary'}
                        variant="contained"
                        onClick={(e) => setAddExam(1)}
                      >
                        Add to Cart <AddShoppingCartIcon />
                      </Button>
                    </Box>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Once you have added all the desired examination paper
                    combinations to your examination cart, click the generate
                    quote button.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {examCount > 0 && (
                        <Button
                          fullWidth
                          color={'primary'}
                          variant="contained"
                          type="submit"
                        >
                          Generate Quote <DescriptionIcon />
                        </Button>
                      )}
                      {(!examCount || examCount === 0) && (
                        <Button
                          fullWidth
                          color={'primary'}
                          variant="contained"
                          disabled
                        >
                          Generate Quote <DescriptionIcon />
                        </Button>
                      )}
                    </Box>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <br />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary"
                    sx={{ textAlign: 'center' }}
                  >
                    To cancel processing an entry or change the selected
                    student, click below.
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Button
                        fullWidth
                        color={'primary'}
                        variant="contained"
                        onClick={(e) => setViewExams(0)}
                      >
                        Cancel <CancelIcon />
                      </Button>
                    </Box>
                    <Box mb={5} />
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Container>
      )}

      {addExam === 1 && (
        <ExaminationAuthList
          venueId={venueId}
          sessionId={sessionId}
          studentId={studentId}
          setAddExam={setAddExam}
          handleComplete={handleComplete}
        />
      )}

      {removeExam === 1 && (
        <RemoveExamAuth
          studentId={studentId}
          setRemoveExam={setRemoveExam}
          removeId={removeId}
          handleComplete={handleComplete}
        />
      )}
    </>
  );
}

export default ViewAuthList;
